import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { URLSearchParams } from '@angular/http';

import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { overlayConfigFactory } from 'angular2-modal';

import { ViewKnowledgeLibraryModalComponent } from './view/view.component';

import { AuthService } from '../../../../../../../providers/auth.service';
import { SharedHackService } from '../../../../../shared/services/shared-hack.service';
import { Subscription } from 'rxjs';
import { ScreenTalentService } from '../../../../screen-talent.service';

declare var $: any;
const MAX_TOTAL_WEIGHT: number = 100;


export class LibraryComponent implements OnInit, OnDestroy {

	 public hackId: string;
	 public test: any;
	 public visibility: string = 'public';

	public totalWeight: number;
	public challenges: any[];
	public tags: any[];
	public addedLibIdsMap: any = {};
	public levels: any[];

	public tagFilterIds: string[] = [];
	public weightIsValid: boolean = false;
	public customValidationErr: string = null;
	public updateInProgress = false;
	public levelFilter: string;
	public eventsSubscription: Subscription;

	constructor(
		public modal: Modal,
		private authService: AuthService,
		private screenTalentService: ScreenTalentService,
		private sharedHackService: SharedHackService) { }

	// Lifecycle Events
	public ngOnInit(): void {
		this.getTags();
		this.getLibrary();
		this.getHackOverview();
		this.setLevels();

		this.eventsSubscription = this.screenTalentService.emitEventAction$.subscribe(
			(data) => {
				this.fetchEvent(data);
			}
		);
	}

	public ngOnDestroy(): void {
		if (this.eventsSubscription) {
			this.eventsSubscription.unsubscribe();
		}
	}

	// Events
	public onViewLibraryClick(challengeId: string): void {
		let data: any = {
			challengeId,
			fromLibrary: true,
			addedInChalenge: !!this.addedLibIdsMap[challengeId],
			hackChallengeId: this.addedLibIdsMap[challengeId] && this.addedLibIdsMap[challengeId].id,
			editable: this.test.status === 'in_progress'
		};
		let modalSettings: any = {
			size: 'lg',
			initData: data,
			isBlocking: false
		};
		this.modal.open(ViewKnowledgeLibraryModalComponent, overlayConfigFactory(modalSettings, BSModalContext))
			.then((result) => { result.result.then(() => undefined, () => undefined); });
	}

	public onAddLibraryClick(lib: any): void {
		this.closeWeightForm();
		lib.weight = null;
		lib['edit_weight'] = true;
	}

	public onEditWeightClick(challenge: any): void {
		this.updateInProgress = true;
		this.closeWeightForm();
		challenge.weight = this.addedLibIdsMap[challenge.id].weight;
		challenge['edit_weight'] = true;
	}

	public onChangePartialScoringClick(challenge, use: boolean) {
		this.sharedHackService.updateKnowledgeTestProperties(String(this.authService.userId), challenge.id, {is_accepting_partial_response: use}).subscribe(
			() => undefined,
			() => undefined,
			() => this.getHackOverview()
		);
	}

	public onChangeAllowCommentClick(challenge, use: boolean) {
		this.sharedHackService.updateKnowledgeTestProperties(String(this.authService.userId), challenge.id, {allow_comment: use}).subscribe(
			() => undefined,
			() => undefined,
			() => this.getHackOverview()
		);
	}

	public onRemoveLibraryClick(lib: any, challengeId: string): void {
		this.sharedHackService.deleteKnwoledgeTestQuestion(String(this.authService.userId), challengeId).subscribe(
			(resp) => {
				this.getHackOverview();
			}
		);
	}

	public onCloseWeightFormClick(lib: any): void {
		this.updateInProgress = false;
		lib['edit_weight'] = null;
		this.customValidationErr = null;
		this.calculateTotalWeight();
	}

	public onAddQuestionSubmitForm(lib: any): void {
		let data = {
			library_id: lib.id,
			weight: lib.weight,
			is_public: this.test.is_public
		};
		this.sharedHackService.postKnwoledgeTestQuestionLibrary(String(this.authService.userId), this.hackId, data).subscribe(
			(resp) => {
				lib['edit_weight'] = null;
				this.updateInProgress = false;
				this.getHackOverview();
			}
		);
	}

	public onUpdateQuestionSubmitForm(lib: any): void {
		lib['edit_weight'] = null;
		this.updateInProgress = false;
		this.sharedHackService.updateKnowledgeTestProperties(String(this.authService.userId), this.addedLibIdsMap[lib.id].id, {weight: lib.weight}).subscribe(
			() => undefined,
			() => undefined,
			() => this.getHackOverview()
		);
	}

	public onWeightInputChange(value: number, challenge): void {
		if (this.updateInProgress) {
			this.addedLibIdsMap[challenge.id].weight = value;
		}
		this.calculateTotalWeight(this.updateInProgress ? 0 : value);

		if (value < 1) {
			if (challenge.type === 'textarea') {
				if (value === 0) {
					this.weightIsValid = true;
					this.customValidationErr = null;
				} else {
					this.weightIsValid = false;
					this.customValidationErr = 'Weight must be at least 0.';
				}
			} else {
				this.weightIsValid = false;
				this.customValidationErr = 'Weight must be grater then 0.';
			}
		} else if (this.totalWeight > MAX_TOTAL_WEIGHT) {
			this.weightIsValid = false;
			this.customValidationErr = 'Total weight exceded (max. 100).';
		} else {
			this.weightIsValid = true;
			this.customValidationErr = null;
		}
	}

	public onChosenChange(changes: any): void {
		if (changes && typeof changes.default !== 'undefined') {
			this.tagFilterIds = changes.default;
			this.getLibrary();
		}
	}

	public onLevelChange(changes: any): void {
		if (changes && typeof changes.default !== 'undefined') {
			this.levelFilter = changes.default;
			this.getLibrary();
		}
	}

	// Service Call
	private getTags(): void {
		this.sharedHackService.getChallengesTags(String(this.authService.userId)).subscribe(
			(tags) => {
				this.tags = tags;
			}
		);
	}

	private closeWeightForm() {
		this.challenges.forEach((item) => {
			item['edit_weight'] = null;
		});

		this.getHackOverview();
	}

	private getLibrary(): void {
		let challengeFilters: URLSearchParams = new URLSearchParams();
		if (this.tagFilterIds.length) {
			this.tagFilterIds.map((tagId) => {
				challengeFilters.append('tags_ids[]', tagId);
			});
		}
		if (this.levelFilter) {
			challengeFilters.append('difficulty', this.levelFilter);
		}

		challengeFilters.append('visibility', this.visibility);
		this.sharedHackService.getKnwoledgeTestQuestionsLibrary(String(this.authService.userId), challengeFilters).subscribe(
			(challenges) => {
				this.challenges = challenges;
			}
		);
	}

	private getHackOverview(): void {
		if (this.hackId) {
			this.sharedHackService.getHack(String(this.authService.userId), this.hackId).subscribe(
				(hack) => {
					let idsObj = {};
					let total: number = 0;
					if (hack.knowledge_test_questions && hack.knowledge_test_questions.length) {
						hack.knowledge_test_questions.map((challenge) => {
							if (challenge.hasOwnProperty('library_id')) {
								idsObj[challenge.library_id] = challenge;
							}
							total += +challenge.weight;
						});
					}
					this.totalWeight = total;
					this.addedLibIdsMap = idsObj;

					this.weightIsValid = false;
					this.customValidationErr = null;
				}
			);
		}
	}

	// Helpers
	private fetchEvent(event: any): void {
		if (event.component && event.component === 'knowledge-library' && event.action) {
			switch (event.action) {
				case 'getHackOverview':
					this.getHackOverview();
					break;
				default:
					// code...
					break;
			}
		}
	}

	private calculateTotalWeight(inputValue = 0): void {
		let total: number = 0;
		Object.keys(this.addedLibIdsMap).forEach((challengeId) => {
			total += +this.addedLibIdsMap[challengeId].weight;
		});
		this.totalWeight = total + inputValue;
	}

	private setLevels(): void {
		this.levels = [
			{
				value: null,
				label: 'All',
			},
			{
				value: '1',
				label: 'Level 1'
			},
			{
				value: '2',
				label: 'Level 2'
			},
			{
				value: '3',
				label: 'Level 3'
			},
			{
				value: '4',
				label: 'Level 4'
			},
			{
				value: '5',
				label: 'Level 5'
			}
		];
	}
static ctorParameters() { return [ { type: Modal }, { type: AuthService }, { type: ScreenTalentService }, { type: SharedHackService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/test/summary/knowledge/library/library.component.ts